import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    ProductType,
    DeliveryServiceType,
    CollectionServiceType,
    LaneStatus,
} from 'app/enums/label.enums'
import {
    SizeLink, TypeLink,
} from 'app/shared-components/SkyNetLink'
import {
    LinkConfig,
} from 'app/common/DomainObject/ComponentMapper/SkyNetTableLink'

export type QuoteLane = {
    changedOn: string,
    laneStatus: LaneStatus,
    destAirportIataCode: string,
    id: number,
    laneComment: string,
    laneNumber: string,
    originAirportIataCode: string,
    selected: boolean,
    expPalletsYear: number,
    deliveryServiceType: DeliveryServiceType,
    collectionServiceType: CollectionServiceType,
    productTypes: ProductType[],
    baseLeaseDays: number[]
}

const columns = ({
    getLabel,
    laneLinkConfig,
}: {
    getLabel: (l: string) => string
    laneLinkConfig?: LinkConfig,
}): RichTableColumns<keyof QuoteLane>[] => {
    return [
        {
            id: 'laneNumber',
            headerProps: {
                children: getLabel('AccountLane.lane'),
            },
            mapCellProps: 'laneNumber',
            componentName: 'SkyNetTableLink',
            type: TypeLink.EXTERNAL,
            size: SizeLink.S,
            linkConfig: laneLinkConfig,
            width: '120px',
        },
        {
            id: 'laneStatus',
            headerProps: {
                children: getLabel('AccountQuotes.laneStatus'),
            },
            filterField: 'laneStatus',
            filterType: FilterType.Array,
            mapCellProps: 'laneStatus',
            componentName: 'EnumValue',
            allowedValuesEnum: LaneStatus,
        },
        {
            id: 'expPalletsYear',
            headerProps: {
                children: getLabel('LaneBasicView.expPalletsYear'),
            },
            mapCellProps: 'expPalletsYear',
        },
        {
            id: 'originAirportIataCode',
            headerProps: {
                children: getLabel('AccountLaneForm.originAirport'),
            },
            filterField: 'originAirportIataCode',
            filterType: FilterType.Array,
            mapCellProps: 'originAirportIataCode',
        },
        {
            id: 'destAirportIataCode',
            headerProps: {
                children: getLabel('AccountLaneForm.destinationAirport'),
            },
            filterField: 'destAirportIataCode',
            filterType: FilterType.Array,
            mapCellProps: 'destAirportIataCode',
        },
        {
            id: 'deliveryServiceType',
            headerProps: {
                children: getLabel('LaneGroup.deliveryServiceType'),
            },
            mapCellProps: 'deliveryServiceType',
            componentName: 'EnumValue',
            allowedValuesEnum: DeliveryServiceType,
        },
        {
            id: 'collectionServiceType',
            headerProps: {
                children: getLabel('LaneGroup.collectionServiceType'),
            },
            mapCellProps: 'collectionServiceType',
            componentName: 'EnumValue',
            allowedValuesEnum: CollectionServiceType,
        },
        {
            id: 'productTypes',
            headerProps: {
                children: getLabel('AccountQuotes.productTypes'),
            },
            mapCellProps: 'productTypes',
            componentName: 'EnumList',
            allowedValuesEnum: ProductType,
            minWidth: '150px',
        },
        {
            id: 'baseLeaseDays',
            headerProps: {
                children: getLabel('AccountQuotes.laneBaseLeaseDays'),
            },
            mapCellProps: ({
                baseLeaseDays,
            }) => {
                return {
                    children: baseLeaseDays.join(', '),
                }
            },
        },
    ]
}

export default columns
